var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ds-modal", {
    attrs: { open: _vm.showModal },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "modal-dialog go-modal-connect" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "modal-title" }, [
                    _vm._v(_vm._s(_vm.$t("scrap-agent.rss.modalTitle"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon close",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.$emit("modal:close")
                        },
                      },
                    },
                    [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "go-form-connect-mode" }, [
                    _c("div", { staticClass: "go-form-body" }, [
                      _c("div", { staticClass: "go-form-group" }, [
                        _c("div", { staticClass: "go-input-group" }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "go-form-group" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("div", { staticClass: "go-block-between" }, [
                          _c("label", { staticClass: "go-form-label" }, [
                            _vm._v(
                              _vm._s(_vm.$t("scrap-agent.rss.enterUrlLabel"))
                            ),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v("*"),
                            ]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("div", { staticClass: "go-input-group" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.formData.url,
                                expression: "formData.url",
                              },
                            ],
                            staticClass: "go-form-control",
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t(
                                "scrap-agent.rss.enterUrlPlaceholder"
                              ),
                            },
                            domProps: { value: _vm.formData.url },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.formData,
                                  "url",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("div", { staticClass: "go-block-between" }, [
                          _c("label", { staticClass: "go-form-label" }, [
                            _vm._v(
                              _vm._s(_vm.$t("scrap-agent.rss.channelNameLabel"))
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("div", { staticClass: "go-input-group" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.formData.channelName,
                                expression: "formData.channelName",
                              },
                            ],
                            staticClass: "go-form-control",
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t(
                                "scrap-agent.rss.channelNamePlaceholder"
                              ),
                            },
                            domProps: { value: _vm.formData.channelName },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.formData,
                                  "channelName",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "modal-footer",
                    staticStyle: { "justify-content": "space-between" },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn go-btn-default",
                        attrs: { type: "button", "data-dismiss": "modal" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.$emit("modal:close")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("scrap-agent.youtube.btnBack")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn go-btn-primary",
                        staticStyle: { "min-width": "220px", height: "38px" },
                        attrs: { type: "button", "data-dismiss": "modal" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.handleAddRssItem.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "go-icon-16 go-icon-plus" }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("scrap-agent.rss.rssRequestButton")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }